import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../../query"
import api from "../../client"
import { GetAddressBookDetailResponseData } from "../../types/address-book"

const getData = async (uuid: string | undefined) => {
  const { data } = await api.get(`/address-book/${uuid}`)
  return data
}

export const useAddressBookDetail = (uuid: string | undefined):
  QueryObserverBaseResult<GetAddressBookDetailResponseData> => {
  const { data, ...props } = useQuery<GetAddressBookDetailResponseData>(
    queryKeys.ADDRESS_BOOK_DETAIL(uuid),
    () => getData(uuid),
    { enabled: Boolean(uuid) }
  )
  return { data, ...props }
}
